<div class="modal-header">
  <h4 class="modal-title">{{(property ? 'managePropertiesDef.title.edit' : 'managePropertiesDef.title.new') | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <form class="w-100" novalidate [formGroup]="form">
      <div class="mb-3 row col-12">
        <label class="col-md-4 col-form-label" for="propertyType">{{'managePropertiesDef.propertyType' | translate}}</label>
        <div class="col-md-8" tooltip [tooltipText]="(isPropertyInUse ? 'managePropertiesDef.propertyInUseError' : '') | translate">
          <select class="form-control select"
                  [class.is-invalid]="form.controls?.propertyType?.touched && form.controls?.propertyType?.invalid"
                  id="propertyType"
                  name="propertyType"
                  formControlName="propertyType"
                  (change)="resetValidation()"
                  [(ngModel)]="selectedPropertyType">
            <option [ngValue]="PropertyTypes.BEHAVIOR">{{'property.type.behavior' | translate}}</option>
            <option [ngValue]="PropertyTypes.PLAUSI">{{'property.type.plausi' | translate}}</option>
            <option [ngValue]="PropertyTypes.CONNECTION">{{'property.type.connection' | translate}}</option>
          </select>
        </div>
        <div *ngIf="form.controls?.propertyType?.touched && form.controls?.propertyType?.invalid" class="ps-3 invalid-feedback d-flex">{{getInputError(form.get('propertyType'))}}</div>
      </div>

      <div class="mb-3 row align-content-center col-12">
        <label class="col-md-4 col-form-label" for="propertyName">{{'managePropertiesDef.propertyName' | translate}}</label>
        <div class="col-md-8" tooltip [tooltipText]="(isPropertyInUse ? 'managePropertiesDef.propertyInUseError' : '') | translate">
          <input type="text"
                 class="form-control"
                 [class.is-invalid]="form.controls?.propertyName?.touched && form.controls?.propertyName?.invalid"
                 id="propertyName"
                 formControlName="propertyName"
                 name="propertyName">
        </div>
        <div *ngIf="form.controls?.propertyName?.touched && form.controls?.propertyName?.invalid" class="ps-3 invalid-feedback d-flex">{{getInputError(form.get('propertyName'))}}</div>
      </div>

      <div class="mb-3 row col-12">
        <label class="col-md-4 col-form-label">{{'managePropertiesDef.propertyValueType' | translate}}</label>
        <div class="col-md-8" dropdown #dropdown="bs-dropdown">
          <button class="button-select form-control border d-flex justify-content-between"
                  [class.error-btn]="valueTypeTouched && form.controls?.propertyValueType?.invalid"
                  data-toggle="dropdown"
                  type="button"
                  dropdownToggle
                  (click)="false">
            <span class="text-overflow">{{checkedValueTypes.join(', ')}}</span>
            <i class="mdi mdi-unfold-more-horizontal"></i>
          </button>
          <ul *dropdownMenu class="w-100 dropdown-menu dropdown-menu-right" (click)="$event.stopPropagation()">
            <li class="col-12 d-flex align-items-center" *ngFor="let valueType of valueTypes">
              <input class="col-1 mx-2"
                     [id]="valueType.name"
                     type="checkbox"
                     [(ngModel)]="valueType.checked"
                     [ngModelOptions]="{standalone: true}"
                     (change)="getSelectedValueTypes(valueType)">
              <label class="col-11 m-0" [for]="valueType.name">{{valueType.name}}</label>
            </li>
          </ul>
        </div>
        <div *ngIf="valueTypeTouched && form.controls?.propertyValueType?.invalid" class="ps-3 invalid-feedback d-flex">{{getInputError(form.get('propertyValueType'))}}</div>
      </div>

      <div class="mb-3 row align-content-center col-12">
        <label class="col-md-4 col-form-label">{{'managePropertiesDef.propertyDescription' | translate}}</label>
        <div class="col-md-8">
          <textarea
                 class="form-control"
                 [class.is-invalid]="form.controls?.propertyDescription?.touched && form.controls?.propertyDescription?.invalid"
                 formControlName="propertyDescription"
                 name="propertyDescription"></textarea>
        </div>
      </div>
      <div class="ps-3 invalid-feedback d-flex">{{getInputError(form.get('propertyDescription'))}}</div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">
    {{'global.label.cancel' | translate}}
  </button>
  <button [disabled]="form.invalid || !checkIfPropertyValueTypesHaveBeenChanged() && !form.dirty" class="btn btn-primary" (click)="save()">
    {{'global.label.save' | translate}}
  </button>
</div>
